'use strict';

// calcul top green - orange -red bars if existing
function calculTopBars () {
  var wooGreenBar = $('#green-bar-counter');
  var wooOrangeBar = $('#orange-bar-counter');
  var wooRedBar = $('#red-bar-counter');
  var greenCounter = $('.criterium.result-1').length;
  var orangeCounter = $('.criterium.result-2').length;
  var redCounter = $('.criterium.result-3').length;
  var totalCounter = greenCounter + orangeCounter + redCounter;

  wooGreenBar.find('.count').text(greenCounter);
  wooOrangeBar.find('.count').text(orangeCounter);
  wooRedBar.find('.count').text(redCounter);

  if (totalCounter > 0) {
    wooGreenBar.find('.progress-bar').stop().animate({
      width: (100 / totalCounter * greenCounter) + '%'
    }, 500);

    wooOrangeBar.find('.progress-bar').stop().animate({
      width: (100 / totalCounter * orangeCounter) + '%'
    }, 500);

    wooRedBar.find('.progress-bar').stop().animate({
      width: (100 / totalCounter * redCounter) + '%'
    }, 500);
  } else {
    $('#dashboard-bars .progress-bar').css('width', '0%');
  }
}

module.exports = calculTopBars;
